import { ReactNode } from "react";
import { CssBaseline, ThemeProvider, Theme } from "@mui/material";
import useSettings from "../../../hooks/useSettings";

interface DashboardThemeProps {
  children: ReactNode;
}

const DashboardTheme = ({ children }: DashboardThemeProps) => {
  const { settings } = useSettings();
  const activeTheme: Theme = { ...settings.themes[settings.activeTheme] };

  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default DashboardTheme;